import React from "react";
import { services } from "../data/services";
export function ServicesStrip() {
  return <section aria-label="Our services" className="border-t border-brand-white/10 px-6 sm:px-10 lg:px-16" data-id="element-54" data-mp="3ck4kqcsato24">
      <ul className="grid grid-cols-2 gap-x-4 gap-y-6 py-7 lg:grid-cols-4 lg:gap-0 lg:py-8" data-id="element-55" data-mp="3qjnt96p0v1ey">
        {services.map(service => {
        const Icon = service.icon;
        return <li key={service.id} className="flex items-start gap-3 sm:gap-4 lg:justify-center lg:border-l lg:border-brand-white/10 lg:px-4 lg:first:justify-start lg:first:border-l-0 lg:first:pl-0" data-id="element-56" data-mp="3e69hl2y8h7j">
              <Icon className="mt-0.5 h-8 w-8 shrink-0 text-brand-white sm:h-9 sm:w-9" strokeWidth={1.2} aria-hidden="true" data-id="element-57" data-mp="d3zluoax10cu" />
              <div data-id="element-58" data-mp="87qzapue24vn">
                <p className="text-[11px] sm:whitespace-nowrap font-semibold uppercase leading-[1.35] tracking-[0.04em] text-brand-white sm:text-[13px]" data-id="element-59" data-mp="n2fcyr9y09mc">
                  {service.lines[0]}
                  <br data-id="element-60" data-mp="24k9sght3fi0f" />
                  {service.lines[1]}
                </p>
                <span className="mt-2 block h-0.5 w-5 bg-brand-red" aria-hidden="true" data-id="element-61" data-mp="24mcszvrvgtje" />
              </div>
            </li>;
      })}
      </ul>
    </section>;
}